import { render, staticRenderFns } from "./ActivityEditForm.vue?vue&type=template&id=483b72e4&"
import script from "./ActivityEditForm.vue?vue&type=script&lang=js&"
export * from "./ActivityEditForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports